<template>
  <section class="el-section" v-if="paymentMethod === 'pix'">
    <div class="el-chunk">
      <div class="el-chunk">
        <span class="emd-text _color_success">
          <i class="uil uil-check-circle" style="font-size: 3rem"></i>
        </span>
      </div>
      <div class="el-chunk">
        <h2 class="emd-text _size_page">
          {{ $t(`pix.orderCreated.success`) }}
        </h2>
      </div>
    </div>
    <p class="el-chunk">
      {{
        $t(`pix.orderCreated.label`, {
          expiresAt: expiresAt,
          totalAmount: totalAmount,
        })
      }}
    </p>
    <img alt='QR Code' :src="qrCodeImage" />
  </section>
</template>

<script>
export default {
  name: 'PixOrderCreated',
  props: {
    paymentMethod: String,
    totalAmount: String
  },
  computed: {
    expiresAt () {
      return this.$store.getters.pix.expires_at
    },
    qrCodeImage () {
      return this.$store.getters.pix.qr_code_url
    }
  }
}
</script>
